import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

const RevealLog = () => {
  const [tab, setTab] = useState('on_my_listings');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const endpoint = tab === 'on_my_listings' ? '/inquiries/reveal/on-my-listings' : '/inquiries/reveal/mine';
    api.get(endpoint).then(({ data }) => setRows(data)).finally(() => setLoading(false));
  }, [tab]);

  return (
    <div className='space-y-5'>
      <div>
        <h1 className='text-2xl font-semibold tracking-tight'>Contact reveal log</h1>
        <p className='text-muted-foreground text-sm'>Every contact reveal on IndusFact is logged for safety and trust.</p>
      </div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList data-testid='reveal-tabs'>
          <TabsTrigger value='on_my_listings'>Who revealed my contact ({tab === 'on_my_listings' ? rows.length : ''})</TabsTrigger>
          <TabsTrigger value='mine'>My reveal history</TabsTrigger>
        </TabsList>
      </Tabs>

      {loading ? (
        <Card className='p-10 text-center text-muted-foreground'>Loading…</Card>
      ) : rows.length === 0 ? (
        <Card className='p-10 text-center text-muted-foreground'>No records yet.</Card>
      ) : (
        <Card className='p-4'>
          <table className='w-full text-sm'>
            <thead className='text-left'>
              <tr className='border-b'>
                <th className='py-2 pr-3'>When</th>
                <th className='py-2 pr-3'>{tab === 'on_my_listings' ? 'Revealed by' : 'On listing'}</th>
                <th className='py-2 pr-3'>Listing</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(r => (
                <tr key={r.id} className='border-b last:border-b-0 hover:bg-secondary/50'>
                  <td className='py-2 pr-3 text-muted-foreground'>{new Date(r.created_at).toLocaleString()}</td>
                  <td className='py-2 pr-3'>{tab === 'on_my_listings' ? `${r.user_name} · ${r.user_email}` : (r.seller_id ? 'Seller' : '—')}</td>
                  <td className='py-2 pr-3'><Link className='text-primary hover:underline' to={`/listing/${r.listing_id}`}>{r.listing_title}</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
};

export default RevealLog;
